import { Field } from 'react-final-form'
import React from 'react'
import StyledTextField from 'components/StyledTextField'

const TextField = ({
  id,
  type,
  name,
  label,
  helperText,
  variant,
  validate,
  InputProps,
  ...props
}) => {
  return (
    <Field
      name={name}
      type={type}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <StyledTextField
            id={id}
            variant={variant}
            label={label}
            type={type}
            helperText={meta.error && meta.touched ? meta.error : helperText}
            InputProps={InputProps}
            error={meta.error && meta.touched}
            {...props}
            {...input}
          />
        )
      }}
    </Field>
  )
}

export default TextField
